const RgCoreVersion = 'RGCOREVERSION!'; //;"16.1.0-next.0"!;

export { RgCoreVersion };
//# sourceMappingURL=core-version.js.map
